import React, { useState, useEffect, useCallback } from 'react';
import TableWrapper from '../../components/Grid';
import { Avatar, Col, Row, Tabs, Tooltip } from 'antd';
import {
    LoadingOutlined,
    UserOutlined,
    PlusOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import SelectField from '../../components/TextField/SelectField';
import Button from '../../components/Button';
import moment from 'moment';
import { FaTrash } from 'react-icons/fa';
import { FaEye } from 'react-icons/fa';
import { ApiCaller, Colors, Utils } from '../../config';
import {
    getEligibiity,
    getSchedules,
    getUserRoles,
} from '../../config/getApis';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import {
    ClientManagementAction,
    SiteManagementAction,
    UserManagementAction,
} from '../../store/actions';
import { Spin, Tag } from 'antd';
import ActionDropdown from '../../components/DropDown/actiondropdown';
import UserAddnEditDrawer from '../UserManagement/UserAddnEditDrawer';
import { phoneNumberFormat } from '../../config/util/PhoneNumberFormatter';
import UserDetailDrawer from '../UserManagement/UserDetailDrawer';
import InviteClients from './InviteClients';
import ClientForm from '../../components/DrawerForms/client';
import BasicDrawer from '../../components/Drawer';
import CompanyDetailDrawer from './CompanyDetailDrawer';
import CompanyEditDrawer from './CompanyEditDrawer';
import InviteClientEditDrawer from './InviteClientEditDrawer';
import { useMutation } from 'react-query';
import { Switch, TextField, ScrollEndMessage } from '../../components';
import { GrUpdate } from 'react-icons/gr';
import { icons } from 'antd/es/image/PreviewGroup';
import useColors from '../../hooks/useColors';

const { TabPane } = Tabs;

const ClientManagement = () => {
    const { colorPrimary } = useColors();

    const dispatch = useDispatch();

    const user = useSelector((state) => state.AppReducer?.user);
    const isRole = user?.userRole[0];

    const updateUserStatusLoader = useSelector(
        (state) => state?.UserManagementReducer?.loader,
    );

    const {
        companiesData,
        invitedClientsData,
        loader,
        companiesDetailData,
        detailLoader,
        invitedClientDetailData,
    } = useSelector((state) => state?.ClientManagementReducer);
    const invitedClientsError = useSelector((state) => state?.ClientManagementReducer?.invitedClientsError);
    const companiesError = useSelector((state) => state?.ClientManagementReducer?.companiesError);
    let managementCompaniesData = companiesData?.data?.data;
    let companiesPagination = companiesData?.data?.paginate;
    let clientsData = invitedClientsData?.data?.data;
    let clientsPagination = invitedClientsData?.data?.paginate;

    const [state, setState] = useState({
        current: 1,
        limit: 20,
        searchVal: '',
        tabName: 'profile',
        tabKey: 1,
        // sortBy: 'id',
        // sortOrder: "asc"
        filterStatus: '',
    });

    const [searchTerm, setSearchTerm] = useState('');
    const [accumulatedClients, setAccumulatedClients] = useState([]);
    const [accumulatedCompanies, setAccumulatedCompanies] = useState([]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setState((prev) => ({
                ...prev,
                current: 1,
                searchVal: searchTerm,
            }));
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    useEffect(() => {
        if (state.tabKey == 1) {
            dispatch(ClientManagementAction.GetInvitedClients(state));
        } else {
            dispatch(ClientManagementAction.GetCompanies(state));
        }
    }, [state.tabKey, state.current, state.limit, state.searchVal, state.filterStatus]);

    useEffect(() => {
        setAccumulatedClients([]);
        setAccumulatedCompanies([]);
    }, [state.tabKey, state.searchVal, state.filterStatus]);

    useEffect(() => {
        if (state.tabKey == 1 && clientsData) {
            if (state.current === 1) {
                setAccumulatedClients(clientsData);
            } else {
                setAccumulatedClients((prev) => {
                    const existingIds = new Set(prev.map((c) => c.id));
                    const newClients = clientsData.filter((c) => !existingIds.has(c.id));
                    return [...prev, ...newClients];
                });
            }
        }
    }, [clientsData, state.current, state.tabKey]);

    useEffect(() => {
        if (state.tabKey != 1 && managementCompaniesData) {
            if (state.current === 1) {
                setAccumulatedCompanies(managementCompaniesData);
            } else {
                setAccumulatedCompanies((prev) => {
                    const existingIds = new Set(prev.map((c) => c.id));
                    const newCompanies = managementCompaniesData.filter((c) => !existingIds.has(c.id));
                    return [...prev, ...newCompanies];
                });
            }
        }
    }, [managementCompaniesData, state.current, state.tabKey]);

    useEffect(() => {
        if (invitedClientsError) {
            setAccumulatedClients([]);
        }
    }, [invitedClientsError]);

    useEffect(() => {
        if (companiesError) {
            setAccumulatedCompanies([]);
        }
    }, [companiesError]);

    const activePaginate = state.tabKey == 1 ? clientsPagination : companiesPagination;
    const hasMore = activePaginate ? (activePaginate.currentPage < activePaginate.lastPage) : true;

    useEffect(() => {
        const container = document.querySelector('.site-layout .ant-layout-content');
        if (!container) return;

        const handleScroll = () => {
            const isNearBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 100;
            if (isNearBottom && !loader && hasMore) {
                setState((prev) => ({
                    ...prev,
                    current: prev.current + 1,
                }));
            }
        };

        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, [loader, hasMore]);

    useEffect(() => {
        const container = document.querySelector('.site-layout .ant-layout-content');
        if (container) {
            container.scrollTop = 0;
        }
    }, [state.tabKey]);

    // Drawers maintaining states.
    const [drawerStates, setDrawerStates] = useState({
        // openDrawer: false,
        userDetailDrawer: false,
        companiesDetailDrawer: false,
        companiesEditDrawer: false,
        inviteClientDrawer: false,
        addClientDrawer: false,
        drawerkey: null,
        userid: null,
    });

    const onCloseDrawer = () => {
        // for users
        if (drawerStates?.drawerkey == 1 && drawerStates.userDetailDrawer) {
            console.log(drawerStates);
            setDrawerStates({
                ...drawerStates,
                userDetailDrawer: false,
                drawerkey: null,
                userid: null,
            });
        }

        // else if (drawerStates.drawerkey == 1 && drawerStates.openDrawer) {
        //     setDrawerStates({ ...drawerStates, openDrawer: false, userDetailDrawer: false, userid: null, drawerkey: null })
        //     dispatch(UserManagementAction.UserDetailReset())
        // }
        else if (
            drawerStates.drawerkey !== 1 &&
            drawerStates.inviteClientDrawer
        ) {
            setDrawerStates({ ...drawerStates, inviteClientDrawer: false });
            console.log(drawerStates);
            return;
        }

        // for companies
        else if (drawerStates.drawerkey !== 1 && drawerStates.addClientDrawer) {
            console.log(drawerStates);
            setDrawerStates({ ...drawerStates, addClientDrawer: false });
            return;
        } else if (
            drawerStates.drawerkey == 1 &&
            drawerStates.companiesDetailDrawer
        ) {
            console.log(drawerStates);
            setDrawerStates({
                ...drawerStates,
                companiesDetailDrawer: false,
                userid: null,
                drawerkey: null,
            });
            return;
        } else if (
            drawerStates.drawerkey == 1 &&
            drawerStates.companiesEditDrawer
        ) {
            console.log(drawerStates);
            setDrawerStates({
                ...drawerStates,
                companiesDetailDrawer: false,
                companiesEditDrawer: false,
                userid: null,
                drawerkey: null,
            });
        }
    };

    // user Select values filter handler
    const SelectFilterHandler = (value) => {
        setState((prev) => ({ ...prev, current: 1, filterStatus: value }));
    };

    // filter basis of values
    const SelectFilterValues = [
        {
            value: 'active',
            label: 'Active',
        },
        {
            value: 'inActive',
            label: 'In-active',
        },
        {
            label: 'View All',
            value: '',
        },
    ];

    // filter basis of search
    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // items for action
    const items = [
        {
            label: state?.tabKey == 1 ? 'View and Edit' : 'View and Edit',
            key: 1,
            icon: <FaEye color="#6A9BFF" />,
            backgroundColor: '#eef4ff',
            color: '#4582ff',
        },
        // {
        //     label: "Status Update",
        //     key: 2,
        //     // icon: <FaTrash color="#E71D36" />,
        //     icon: <GrUpdate color="#E71D36" />,
        //     backgroundColor: "#fef3f5",
        //     color: "#e93148",
        // },
    ];

    // Profile action handler
    const inviteActionHandler = (e, record) => {
        const { current, limit, searchVal } = state;
        let id = Number(record?.id);

        if (e.key == '1') {
            setDrawerStates({
                ...drawerStates,
                userDetailDrawer: true,
                drawerkey: 1,
                userid: id,
            });
            dispatch(ClientManagementAction.GetInvitedClientDetail(id));
        }

        // else {
        //     if (record?.status == 'active') {
        //         let payload = {
        //             id,
        //             status: 'inActive'
        //         }
        //         dispatch(UserManagementAction.UpdateUserStatus(payload, () => {
        //             dispatch(ClientManagementAction.GetInvitedClients({ ...state, current: current, limit: limit, searchVal: searchVal }))
        //         }))
        //         setState({ ...state, current: current, limit: limit, searchVal: searchVal })
        //     }
        //     else {
        //         let payload = {
        //             id,
        //             status: 'active'
        //         }
        //         dispatch(UserManagementAction.UpdateUserStatus(payload, () => {
        //             dispatch(ClientManagementAction.GetInvitedClients({ ...state, current: current, limit: limit, searchVal: searchVal }))
        //         }))
        //         setState({ ...state, current: current, limit: limit, searchVal: searchVal })
        //     }
        //     return
        // }
    };

    // companies action handler
    const companiesActionHandler = (e, record) => {
        let id = Number(record?.id);
        const { current, limit, searchVal } = state;

        if (e.key == '1') {
            setDrawerStates({
                ...drawerStates,
                companiesDetailDrawer: true,
                drawerkey: 1,
                userid: id,
            });
            dispatch(ClientManagementAction.GetCompanyDetails(id));
        }
        // else {
        //     if (record?.status == 'active') {
        //         let payload = {
        //             id,
        //             status: 'inActive'
        //         }
        //         setState({ ...state, current: current, limit: limit, searchVal: searchVal })
        //     }
        //     else {
        //         let payload = {
        //             id,
        //             status: 'active'
        //         }
        //         setState({ ...state, current: current, limit: limit, searchVal: searchVal })
        //     }
        //     return
        // }
    };

    const handleProfileRowClick = (record, event) => {
        if (event.target.closest('.ant-switch') || event.target.closest('.ant-dropdown-trigger')) {
            return;
        }
        let id = Number(record?.id);
        setDrawerStates({
            ...drawerStates,
            userDetailDrawer: true,
            drawerkey: 1,
            userid: id,
        });
        dispatch(ClientManagementAction.GetInvitedClientDetail(id));
    };

    const handleCompanyRowClick = (record, event) => {
        if (event.target.closest('.ant-switch') || event.target.closest('.ant-dropdown-trigger')) {
            return;
        }
        let id = Number(record?.id);
        setDrawerStates({
            ...drawerStates,
            companiesDetailDrawer: true,
            drawerkey: 1,
            userid: id,
        });
        dispatch(ClientManagementAction.GetCompanyDetails(id));
    };

    // Function to handle tab change
    const handleTabChange = (key) => {
        setSearchTerm('');
        setState((prev) => ({
            ...prev,
            tabKey: key,
            tabName: key == 1 ? 'profile' : 'companies',
            current: 1,
            searchVal: '',
            filterStatus: '',
        }));
        if (key == 1) {
            dispatch(SiteManagementAction.GetProperties());
        }
    };

    // handle invite client
    const handleInviteClient = () => {
        setDrawerStates({ ...drawerStates, inviteClientDrawer: true });
    };

    // handle Add New Company
    const handleAddClient = () => {
        setDrawerStates({ ...drawerStates, addClientDrawer: true });
    };

    // Company edit drawer handler
    const CompanyeditHandler = () => {
        setDrawerStates({
            ...drawerStates,
            companiesDetailDrawer: false,
            companiesEditDrawer: true,
        });
    };

    // profile status active and inactive handler
    const profileStatusHandler = (status, event, record) => {
        let id = Number(record?.id);
        let payload = {
            id,
            status: status ? 'active' : 'inActive',
        };
        dispatch(
            UserManagementAction.UpdateUserStatus(payload, () => {
                setAccumulatedClients([]);
                setState((prev) => ({ ...prev, current: 1 }));
                if (state.current === 1) {
                    dispatch(ClientManagementAction.GetInvitedClients({ ...state, current: 1 }));
                }
            }),
        );
    };

    // company status active and inactive handler
    const companyStatusHandler = (status, event, record) => {
        let id = Number(record?.id);
        let payload = {
            id,
            status: status ? 'active' : 'inActive',
        };
        dispatch(
            ClientManagementAction.CompanyStatusUpdate(payload, () => {
                setAccumulatedCompanies([]);
                setState((prev) => ({ ...prev, current: 1 }));
                if (state.current === 1) {
                    dispatch(ClientManagementAction.GetCompanies({ ...state, current: 1 }));
                }
                dispatch(SiteManagementAction.GetProperties());
            }),
        );
    };

    // PROFILE USER COLUMNS
    const ClientsColumns = [
        {
            title: 'Name',
            dataIndex: 'userName',
            align: 'left',
            render: (text, record) => (
                <Col span={24} className="flex justify-start items-center">
                    {/* {
                        record?.profileImg ?
                            <Avatar className='mr-5' size={40} src={record?.profileImg[0]?.url} />
                            :
                            <Avatar className='mr-5' size={40} icon={<UserOutlined />} />
                    } */}
                    <span>{record?.firstName + ' ' + record?.lastName}</span>
                </Col>
            ),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="w-full flex justify-start align-center flex-wrap"
                    >
                        <span className="break-all">{record?.email}</span>
                    </Col>
                );
            },
        },
        {
            title: 'Phone#',
            dataIndex: 'phoneNo',
            key: 'phone',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span>{record?.phoneNo}</span>
                    </Col>
                );
            },
        },
        {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                            justifyContent: 'start',
                        }}
                    >
                        {record?.company?.length > 0 && (
                            <Tag
                                color={
                                    record?.company.length > 0
                                        ? record?.company[0]?.status == 'active'
                                            ? 'success'
                                            : 'error'
                                        : ''
                                }
                            >
                                {record?.company?.length > 0
                                    ? record?.company[0]?.status
                                    : ''}
                            </Tag>
                        )}
                        <span>
                            {record?.company?.length > 0
                                ? record?.company[0]?.name
                                : '-'}
                        </span>
                    </Col>
                );
            },
        },

        {
            title: 'Last Access',
            dataIndex: 'eligibilities',
            key: 'elegibility',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span className="">
                            {record?.lastLogin ? record?.lastLogin : '-'}
                        </span>
                    </Col>
                );
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-start align-center gap-2"
                    >
                        <span
                            className={`rounded`}
                            style={{
                                background:
                                    record?.status == 'active'
                                        ? colorPrimary
                                        : '#FF474D',
                                color: Colors.White,
                                padding:
                                    record?.status == 'active'
                                        ? '6px 16px'
                                        : '6px 10px',
                            }}
                        >
                            {record?.status ? record?.status.charAt(0).toUpperCase() + record?.status.slice(1) : '-'}
                        </span>
                        <Switch.Basic
                            className="cursor-pointer"
                            checked={record?.status == 'active' ? true : false}
                            onChange={(checked, event) =>
                                profileStatusHandler(checked, event, record)
                            }
                            containerStyle={{ paddingTop: '5px' }}
                        />
                    </Col>
                );
            },
        },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-center align-center"
                        style={{}}
                    >
                        <ActionDropdown
                            items={items}
                            placement={'bottom'}
                            labelStyle={{
                                color: colorPrimary,
                                fontSize: '1.2rem',
                                marginBottom: '7px',
                            }}
                            onClick={(e) => inviteActionHandler(e, record)}
                            isRole={isRole}
                        />
                    </Col>
                );
            },
        },
    ];

    const managementColumns = [
        {
            title: 'Company Name',
            dataIndex: 'name',
            align: 'left',
            render: (text, record) => (
                <Col span={24}>
                    <span className="break-all">{record?.name}</span>
                </Col>
            ),
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            align: 'left',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-start align-center flex-wrap"
                    >
                        {record?.address?.map((item) => {
                            return (
                                <span key={item?.id} className="break-all">
                                    {item?.streetNumber +
                                        ' ' +
                                        item?.streetName}
                                </span>
                            );
                        })}
                    </Col>
                );
            },
        },
        {
            title: 'Phone#',
            dataIndex: 'phoneNumber',
            key: 'phone',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span>{record?.phoneNumber}</span>
                    </Col>
                );
            },
        },

        // {
        //     title: 'Email',
        //     dataIndex: 'email',
        //     key: 'email',
        //     render: (text, record) => {
        //         return (
        //             <Col span={24} className='w-full'>
        //                 <span className='break-all'>{record?.email || '-'}</span>
        //             </Col>

        //         )
        //     }

        // },

        {
            title: 'Properties',
            dataIndex: 'propertiesCount',
            key: 'propertiesCount',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span>{record?.propertiesCount}</span>
                    </Col>
                );
            },
        },
        {
            title: 'Incidents',
            dataIndex: 'incidentsCount',
            key: 'incidentsCount',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span>{record?.incidentsCount}</span>
                    </Col>
                );
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-start align-center gap-2"
                    >
                        <span
                            className={`rounded`}
                            style={{
                                background:
                                    record?.status == 'active'
                                        ? colorPrimary
                                        : '#FF474D',
                                color: Colors.White,
                                padding:
                                    record?.status == 'active'
                                        ? '6px 16px'
                                        : '6px 10px',
                            }}
                        >
                            {record?.status ? record?.status.charAt(0).toUpperCase() + record?.status.slice(1) : '-'}
                        </span>
                        <Switch.Basic
                            className="cursor-pointer"
                            checked={record?.status == 'active' ? true : false}
                            onChange={(checked, event) =>
                                companyStatusHandler(checked, event, record)
                            }
                            containerStyle={{ paddingTop: '5px' }}
                        />
                    </Col>
                );
            },
        },

        {
            title: 'Action',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-center align-center"
                        style={{}}
                    >
                        <ActionDropdown
                            items={items}
                            placement={'bottom'}
                            labelStyle={{
                                color: colorPrimary,
                                fontSize: '1.2rem',
                                marginBottom: '7px',
                            }}
                            onClick={(e) => companiesActionHandler(e, record)}
                            isRole={isRole}
                        />
                    </Col>
                );
            },
        },
    ];

    return (
        <>
            {/* // Profile tab working of Invite Client, user Details and Edit drawers  */}

            <InviteClients
                openDrawer={drawerStates?.inviteClientDrawer}
                onCloseDrawer={onCloseDrawer}
            />

            <InviteClientEditDrawer
                openDrawer={drawerStates?.userDetailDrawer}
                onCloseDrawer={onCloseDrawer}
                invitedClientDetailData={invitedClientDetailData}
                detailLoader={drawerStates?.userDetailDrawer && detailLoader}
                state={state}
                setState={setState}
                width={500}
            />

            <div className="w-full flex items-center justify-between gap-3 my-4" style={{ flexWrap: 'wrap' }}>
                <h1 className="text-xl font-semibold m-0" style={{ flexShrink: 0 }}>Client Management</h1>
                <div className="flex items-center gap-3" style={{ flexShrink: 0 }}>
                    <div style={{ width: '260px' }}>
                        <TextField.Basic
                            style={{ background: '#eff2f5', width: '100%', margin: 0 }}
                            suffix={<SearchOutlined style={{ fontSize: '18px', color: '#888' }} />}
                            placeholder="Search..."
                            onChange={(e) => handleInputChange(e)}
                            id="search"
                            name="search"
                            value={searchTerm}
                            className="placeholder-red outline-none w-full py-2 px-4"
                        />
                    </div>

                    <div style={{ width: '160px', flexShrink: 0 }}>
                        <SelectField
                            value={state?.filterStatus}
                            style={{ backgroundColor: '#eff2f5' }}
                            className="w-full h-10"
                            onChange={(val) => SelectFilterHandler && SelectFilterHandler(val)}
                            options={SelectFilterValues}
                            placeholder="View All"
                        />
                    </div>

                    {(isRole === 'admin' || isRole === 'manager') && (
                        <Button.Basic
                            className="text-white outline-none border-none cursor-pointer"
                            style={{
                                height: '40px',
                                flexShrink: 0,
                                background: colorPrimary,
                                color: Colors.White,
                                paddingLeft: '20px',
                                paddingRight: '20px',
                                borderRadius: '8px',
                                fontWeight: 500,
                                letterSpacing: '0.3px',
                            }}
                            text={state?.tabKey == 1 ? 'Invite Clients' : 'Add New Company'}
                            icon={<PlusOutlined />}
                            onClick={() => (state?.tabKey == 1 ? handleInviteClient() : handleAddClient())}
                        />
                    )}
                </div>
            </div>

            {/* Add Client or Company working, Detail of Company along with the Edit drawer */}

            <BasicDrawer
                openDrawer={drawerStates?.addClientDrawer}
                title={'Add management company'}
                onClose={onCloseDrawer}
                width={'800'}
            >
                <ClientForm
                    onCloseDrawer={onCloseDrawer}
                    isCompaniesListing={true}
                />
            </BasicDrawer>

            <CompanyDetailDrawer
                openDrawer={drawerStates?.companiesDetailDrawer}
                onCloseDrawer={onCloseDrawer}
                isRole={isRole}
                companyDetailData={companiesDetailData}
                width={500}
                CompanyeditHandler={CompanyeditHandler}
                isLoading={detailLoader}
            />

            <CompanyEditDrawer
                openDrawer={drawerStates?.companiesEditDrawer}
                onCloseDrawer={onCloseDrawer}
                companyDetailData={companiesDetailData && companiesDetailData}
                setState={setState}
                state={state}
                width={600}
            />

            <Row
                gutter={[8, 32]}
                className="w-fit sm:w-fit lg:w-fit xl:w-full"
                style={{
                    background: 'white',
                    padding: '16px',
                    borderRadius: '10px',
                }}
            >
                <Col lg={24}>
                    <Row className="w-full">
                        <Col lg={24}>
                            <Tabs
                                defaultActiveKey="1"
                                itemSelectedColor="black"
                                style={{
                                    fontWeight: '500',
                                }}
                                onChange={handleTabChange}
                                items={[
                                    {
                                        label: 'Profile',
                                        key: '1',
                                        children: (
                                            <>
                                                <TableWrapper
                                                    tableStyle={{
                                                        borderRadius: '40px',
                                                        width: '100%',
                                                    }}
                                                    headerbg={'red'}
                                                    tableColumns={
                                                        ClientsColumns
                                                    }
                                                    tableData={accumulatedClients}
                                                    pagination={false}
                                                    rowClassName={'row-antd'}
                                                    onRow={(record) => ({
                                                        onClick: (event) => handleProfileRowClick(record, event),
                                                    })}
                                                />
                                                {(loader || updateUserStatusLoader) && (
                                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                                                        <Spin />
                                                    </div>
                                                )}
                                                <ScrollEndMessage
                                                    hasMore={hasMore}
                                                    loading={loader || updateUserStatusLoader}
                                                    dataLength={accumulatedClients?.length}
                                                />
                                            </>
                                        ),
                                    },

                                    {
                                        label: 'Management Companies',
                                        key: '2',
                                        children: (
                                            <>
                                                <TableWrapper
                                                    tableStyle={{
                                                        borderRadius: '40px',
                                                    }}
                                                    headerbg={'red'}
                                                    tableColumns={
                                                        managementColumns
                                                    }
                                                    tableData={
                                                        accumulatedCompanies
                                                    }
                                                    pagination={false}
                                                    rowClassName={'row-antd'}
                                                    onRow={(record) => ({
                                                        onClick: (event) => handleCompanyRowClick(record, event),
                                                    })}
                                                />
                                                {(loader || updateUserStatusLoader) && (
                                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                                                        <Spin />
                                                    </div>
                                                )}
                                                <ScrollEndMessage
                                                    hasMore={hasMore}
                                                    loading={loader || updateUserStatusLoader}
                                                    dataLength={accumulatedCompanies?.length}
                                                />
                                            </>
                                        ),
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default ClientManagement;
